import { heroStats } from '@/mocks/homeData';

const marqueeItems = [
  '截图链 486 份在库',
  '录音原件 197 段已降噪',
  '视频实拍 154 条时间码对齐',
  '聊天记录 302 组已对照',
  '文件解析 147 份含哈希',
  '时间线锤 318 个节点持续更新',
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20moody%20collage%20of%20scattered%20documents%2C%20chat%20bubbles%2C%20screenshot%20frames%20and%20red%20string%20connections%20on%20a%20deep%20jade%20green%20archive%20desk%2C%20dramatic%20cinematic%20side%20lighting%2C%20editorial%20magazine%20cover%20art%2C%20high%20contrast%2C%20muted%20warm%20amber%20accents&width=1600&height=900&seq=gt-hero-main&orientation=landscape"
          alt="瓜田黑料实锤证据存档主视觉"
          title="瓜田黑料实锤证据存档 · 时间线锤持续更新"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/85 via-foreground-950/72 to-foreground-950/92" />

      <div className="relative z-10 w-full pt-32 md:pt-40 pb-14 md:pb-20">
        <div className="w-full px-4 md:px-10">
          <div className="w-full max-w-4xl mx-auto flex flex-col items-center text-center">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-background-100/25 bg-background-50/10 text-background-100 text-xs md:text-sm backdrop-blur-sm animate-fade-in">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-soft-pulse" />
              证据存档中 · 瓜田黑料时间线锤持续更新
            </span>

            <h1 className="mt-6 text-3xl md:text-6xl font-bold leading-[1.15] text-background-50 text-balance animate-fade-up">
              瓜田黑料网
              <span className="block mt-3 text-xl md:text-3xl font-semibold text-secondary-100">
                实锤证据已存档，对线前先看这一页
              </span>
            </h1>

            <p className="mt-6 max-w-3xl text-sm md:text-base leading-relaxed text-background-100/85 animate-fade-up">
              实锤证据集中存档，截图、录音、视频、聊天记录、文件解析一站看。时间线锤整理清晰，
              吃瓜不怕没证据，收藏这篇随时对线，让黑料无处遁形。
            </p>

            <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-3 w-full sm:w-auto">
              <a
                href="#archive"
                className="px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-folder-shield-2-line" />
                进入证据归档库
              </a>
              <a
                href="#timeline"
                className="px-7 py-3.5 rounded-md border border-background-100/35 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
              >
                <i className="ri-time-line" />
                查看瓜田黑料时间线锤
              </a>
            </div>
          </div>

          <div className="mt-14 md:mt-20 w-full grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
            {heroStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-100/15 bg-background-50/10 backdrop-blur-sm px-4 py-4 md:px-5 md:py-5"
              >
                <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-md bg-accent-500/20 text-accent-200 text-lg">
                  <i className={stat.icon} />
                </div>
                <p className="mt-3 md:mt-4 text-xl md:text-3xl font-bold text-background-50">
                  {stat.value}
                  <span className="ml-1 text-xs md:text-sm font-normal text-background-100/70">
                    {stat.unit}
                  </span>
                </p>
                <p className="mt-1 text-xs md:text-sm text-background-100/70">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full border-t border-background-100/15 bg-foreground-950/60 backdrop-blur-sm overflow-hidden">
        <div className="flex w-max animate-marquee">
          {[0, 1].map((loop) => (
            <div key={loop} className="flex items-center">
              {marqueeItems.map((item) => (
                <span
                  key={`${loop}-${item}`}
                  className="flex items-center gap-3 px-6 py-3 text-xs md:text-sm text-background-100/70 whitespace-nowrap"
                >
                  <i className="ri-checkbox-blank-circle-fill text-[6px] text-accent-400" />
                  {item}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}